import { Admin as RaAdmin, CustomRoutes } from 'react-admin'
import { Route } from 'react-router-dom'
import log from 'loglevel'
import React from 'react'

import { CompleteForm } from 'components/Complete'
import { LayoutWithoutTitle } from 'components/Layout'

log.setLevel(log.levels.DEBUG)

export const Admin: React.FC = () => {
  return (
    <RaAdmin layout={LayoutWithoutTitle}>
      <CustomRoutes>
        <Route path="/complete/" element={<CompleteForm />} />
      </CustomRoutes>
    </RaAdmin>
  )
}
